(function($) {
    $(document).ready(function() {
      // Cache the button selector for better performance
      var assessmentButton = $('.assessment_button');
      var scrollThreshold = 100; // Pixels to scroll before showing the button
  
      // Function to check scroll position and toggle button visibility
      function checkScroll() {
        var scrollPos = $(window).scrollTop(); // Get current vertical scroll position
  
        if (scrollPos >= scrollThreshold) {
          // If scrolled down enough, make the button visible and opaque
          assessmentButton.css('visibility', 'visible').css('opacity', 1);
        } else {
          // Otherwise, make it hidden and transparent
          assessmentButton.css('opacity', 0).css('visibility', 'hidden');
          // Note: Setting opacity first then visibility might feel slightly smoother
          // during fade-out if the CSS transition wasn't perfectly timed,
          // but with the existing transition, either order should work.
        }
      }
  
      // Listen for scroll events on the window
      $(window).on('scroll', checkScroll);
  
      // Optional: Run the check once on page load
      // This handles cases where the page might load already scrolled down
      // (e.g., after a refresh or navigating back)
      checkScroll();
  
    });
  })(jQuery); // Ensure jQuery is loaded before this script runs